
import { intl } from "LocaleWrapper";
import { useQuery } from "@apollo/client";
import { Select, SelectProps } from "@cofano/cck";
import { ChildPropsFromArray } from "types/commons";
import { GetDeliveryConditionsDocument, GetDeliveryConditionsQuery } from "__generated__/view/deliveryconditions/graphql/deliveryCondition.queries.generated";

type DeliveryConditionSelectOption = ChildPropsFromArray<GetDeliveryConditionsQuery, "deliveryConditions">;

const DeliveryConditionSelect = <Multiple extends boolean,>({
	...rest
}: Omit<SelectProps<DeliveryConditionSelectOption, Multiple>, "fetchOptions" | "paginated">) => {

	const { data } = useQuery(GetDeliveryConditionsDocument);

	return (
		<Select
			fetchOptions={data?.deliveryConditions ?? []}
			getOptionLabel={(option) => option.description}
			loadingLabel={intl.formatMessage({ id: "LOADING_DATA" })}
			{...rest}
		/>
	);
};

export default DeliveryConditionSelect;
